<div class="sidebar-filters-content collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header">
        <button class="row collapse-title btn pl-0 pr-0 pt-0 pb-0"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample"
                data-toggle="collapse"
                role="button">
          <h6>{{ 'BUDGET.CATEGORIES_BUDGET_TYPE' | translate }}</h6>
        </button>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseExample">
        <div class="card">
          <div class="card-body p-0">
            <div class="categories-list">
              <div class="category-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="budgetsSelection[1]"
                         id="budget-type-general" (change)="checkCategory()"/>
                  <label class="custom-control-label"
                         for="budget-type-general">{{ 'BUDGET.STANDARD_SHORT' | translate }}</label>
                </div>
              </div>
              <div *ngIf="companyInfo?.hasProfessionalDevelopmentBudget" class="category-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="budgetsSelection[professionalDevelopmentValue]"
                         id="budget-type-professionalDevelopment" (change)="checkCategory()"/>
                  <label class="custom-control-label"
                         for="budget-type-professionalDevelopment">{{ 'BUDGET.PROFESSIONAL_DEVELOPMENT_SHORT' | translate }}</label>
                </div>
              </div>
              <div *ngIf="companyInfo?.hasTransportBudget" class="category-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="budgetsSelection[transportValue]"
                         id="budget-type-transport" (change)="checkCategory()"/>
                  <label class="custom-control-label"
                         for="budget-type-transport">{{ 'BUDGET.TRANSPORT_SHORT' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
